export const openModal = (modalId) => {
    $(`#${modalId}`).show();
}

export const closeModal = (modalId) => {
    $(`#${modalId}`).hide();
}

export const escapaHtml = (texto) => {
    if (texto === null || texto === undefined) return '';
    return String(texto)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

export const escapaJsEnAtributo = (texto) => {
    if (texto === null || texto === undefined) return '';
    return escapaHtml(String(texto).replace(/\\/g, '\\\\').replace(/'/g, "\\'"));
}

export const debounce = (func, wait) => {
    let timeout;
    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}

